import React from "react";
import { __ } from "services/Translator";

// One pill for every transport. It reports what the player can expect, not
// which technology is underneath: "live" and "polling" both mean the thread is
// current, so they read the same. Only a genuinely broken connection says
// something different, and it says the honest thing rather than "reconnecting"
// forever: with the websocket dark and the poll failing, the reply really will
// come by email.
export default function TransportPill({ state }) {
  if (state === "idle") {
    return null;
  }

  let label;
  let tone;
  if (state === "degraded") {
    label = __("We will reply by email");
    tone = "isDegraded";
  } else if (state === "connecting") {
    label = __("Connecting");
    tone = "isConnecting";
  } else {
    label = __("Live");
    tone = "isLive";
  }

  return (
    <span className={"supPill " + tone} role="status">
      <span className="supPillDot" aria-hidden="true" />
      {label}
    </span>
  );
}
